import { fetchPackages } from 'Api/AccountApi';
import { logger } from 'Utils/Logger';
import {
  GET_PLANS_SUCCESS,
  GET_PLANS_REQUEST,
  SELECT_PLAN,
  CLEAR_PLANS,
  CLEAR_SELECTED_PLAN,
  DISABLE_FREE_PROMO,
  DISABLE_DEFAULT_PROMO,
} from '../Types';

// action creators
export const fetchPlansRequest = (payload) => ({ type: GET_PLANS_REQUEST, payload });
export const fetchPlans = (payload) => ({ type: GET_PLANS_SUCCESS, payload });
export const setSelectedPlan = (payload) => ({ type: SELECT_PLAN, payload });
export const clearPlans = (payload) => ({ type: CLEAR_PLANS, payload });
export const clearSelectedPlan = () => ({ type: CLEAR_SELECTED_PLAN });
export const disableFreePromo = () => ({ type: DISABLE_FREE_PROMO });
export const disableDefaultPromo = () => ({ type: DISABLE_DEFAULT_PROMO });

// action thunks
export const selectPlan =
  (planId = '') =>
  async (dispatch, getState) => {
    const {
      plans: { allPlans, selectedPlanId },
      appConfig: {
        defaultConfig: { defaultPackage },
      },
      purchaseMode: { requirePlanSelection },
    } = getState();
    logger.started('select plan', { planId });
    const defaultSelectedPlan = requirePlanSelection ? '' : defaultPackage;
    const serviceId = planId || selectedPlanId || defaultSelectedPlan;
    const selectedPlan = allPlans.find(({ packageID }) => packageID === serviceId) || null;
    if (selectedPlan) {
      logger.completed('select plan', { planId, selectedPlan, selectedPlanId });
      dispatch(
        setSelectedPlan({
          selectedPlan,
          selectedPlanId: serviceId,
          selectedPlanPrice: selectedPlan.planPrice || 0,
        })
      );
    } else {
      const error = `Plan not found for planId: '${serviceId}'`;
      logger.error('select plan', { selectedPlan, selectedPlanId, requirePlanSelection, serviceId }, error);
    }
  };

export const getPlans = () => async (dispatch) => {
  logger.started('get plans');
  dispatch(fetchPlansRequest());
  const allPlans = await fetchPackages();
  logger.completed('get plans', { allPlans });
  dispatch(fetchPlans({ allPlans }));
};

export const selectRestartPlan = (selectedPlan) => (dispatch) => {
  logger.started('select restart plan', { selectedPlan });
  dispatch(setSelectedPlan({ selectedPlan }));
  logger.completed('select restart plan', { selectedPlan });
};
